/**
 * Tap-to-paint navigation timing. Nav chrome calls markNavStart at the tap;
 * the destination layout reports the elapsed time on its first painted frame
 * after the route commits. Sent to PostHog so transition regressions show up
 * in production numbers instead of app-store reviews.
 */
let navMark: { label: string; startedAt: number } | null = null;

export const markNavStart = (label: string): void => {
  navMark = { label, startedAt: performance.now() };
};

export const takeNavMark = (): { label: string; startedAt: number } | null => {
  const mark = navMark;
  navMark = null;
  return mark;
};
